import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ProductCatalog from "./components/ProductCatalog";
import HowItWorks from "./components/HowItWorks";
import Features from "./components/Features";
import Integrations from "./components/Integrations";
import PrintingTech from "./components/PrintingTech";
import GlobalShipping from "./components/GlobalShipping";
import ContactForm from "./components/ContactForm";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

// Pages
import DownloadPage from "./pages/DownloadPage";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-coastal-offwhite">
      <Header />
      <main>
        <HeroSection />
        <ProductCatalog />
        <HowItWorks />
        <Features />
        <Integrations />
        <PrintingTech />
        <GlobalShipping />
        <ContactForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/download" element={<DownloadPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
